import React, { useEffect, useState } from "react";
import AgentsModule from "../../components/ui/support_admin/agents.tsx";
import CustomersModule from "../../components/ui/support_admin/customers.tsx";
import TelefonSMSModule from "../../components/ui/support_admin/telephonesms.tsx";
import AdministerVoipModule from "../../components/ui/support_admin/administervoip.tsx";
import AgentDetailModule from "../../components/ui/support_admin/agentdetail.tsx";
import SkillsModule from "../../components/ui/support_admin/skills.tsx";
import ReportsModule from "../../components/ui/support_admin/reports.tsx";
import CmsAndInnholdModule from "../../components/ui/support_admin/cms.tsx";
import { useNavigate } from "react-router-dom";
import HeaderModule from "../../components/ui/support_admin/header.tsx";
import SidebarModule from "../../components/ui/support_admin/sidebar.tsx";
import EnlargedCardModalModule from "../../components/ui/support_admin/enlargecardmodal.tsx";
import DashboardModule from "../../components/ui/support_admin/dashboard.tsx";
import axios from "axios";
import SocialMediaModule from "../../components/ui/support_admin/socialmedia.tsx";
import KursAndEventerModule from "../../components/ui/support_admin/kursandeventer.tsx";
import { RootState } from "../../state/store.ts";
import { useSelector } from "react-redux";
import InnstillingerModule from "../../components/ui/support_admin/innstillinger.tsx";
import BlogDetail from "../../components/ui/support_admin/blogdetail.tsx";
import BlogsList from "../../components/ui/support_admin/blogslist.tsx";
import AdministerTelefoni from "../../components/ui/support_admin/administertelefoni.tsx";

type ClientDashboardProps = {
    currentUser: any,
    onLogout: () => void,
    baseUrl: string,
    onRegisterClick: () => void,
    onLoginClick: () => void,
    onLoginSuccess: () => void,
}
export default function ClientDashboard({ currentUser, onLogout, baseUrl, onRegisterClick, onLoginClick, onLoginSuccess }: ClientDashboardProps) {
    const [enlargedCard, setEnlargedCard] = useState<null | {
        label: string;
        value: string;
        trend: string;
    }>(null);
    const [mobileMenu, setMobileMenu] = useState(false);

    const [selectedAgent, setSelectedAgent] = useState(null);

    const navigate = useNavigate();
    useEffect(() => {
        // If there's no current user, or the user's role is neither 'support' nor 'client', redirect home
        if (!currentUser || (currentUser.role !== 'support' && currentUser.role !== 'client' && currentUser.role !== 'admin')) {
            navigate('/'); // Redirect to home if not logged in or not a support or client
        }
    }, [currentUser, navigate]);

    const [tab, setTab] = useState(localStorage.getItem('supportCurrentTab') || "Dashboard");

    useEffect(() => {
        localStorage.setItem('supportCurrentTab', tab);
    }, [tab])

    const [profile, setProfile] = useState<any>(null);
    const client = useSelector((state: RootState) => state.client.client);

    useEffect(() => {

        axios.get(`${baseUrl}/getSupportByUid`, { params: { token: currentUser.token } })
            .then((response) => {

                if (response.data.status === "OK") {
                    setProfile(response.data.data);
                } else {
                    setProfile(null);
                }
            })
            .catch((err) => {
                console.error(err)
            });
    }, [currentUser?.token, baseUrl]);

    const checkClientStripeConnected = async () => {
        try {
            const response = await axios.get(baseUrl + "/checkClientStripeConnected", {
                params: { client_uid: client?.uid, token: currentUser?.token }
            });
            return response.data.data;
        } catch (err) {
            console.error(err);
            return false;
        }
    };

    useEffect(() => {
        if (!client || !currentUser) return;
        checkClientStripeConnected().then((response) => {
            if (response.flag === 3) {
                window.location.href = response.url; // Redirect to Stripe KYC
            } else if (response.flag === 0 || response.flag === 1) {
                navigate("/support-admin/dashboard"); // Redirect to payment settings in dashboard
            }
        });
    }, [client, currentUser])

    const [selectedEvent, setSelectedEvent] = useState<any>(null);

    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

    return (
        <div className="min-h-screen bg-slate-50 text-slate-900 flex flex-col md:flex-row">
            {/* SIDEBAR */}
            <SidebarModule tab={tab} setTab={setTab} mobileMenu={mobileMenu} setMobileMenu={setMobileMenu} profile={profile} baseUrl={baseUrl} onLogout={onLogout} sidebarCollapsed={sidebarCollapsed} setSidebarCollapsed={setSidebarCollapsed} />

            {/* MAIN */}
            <div className="flex-1 flex flex-col min-w-0">

                <HeaderModule tab={tab} setTab={setTab} currentUser={currentUser} onLogout={onLogout} profile={profile} baseUrl={baseUrl} setSelectedAgent={setSelectedAgent} />
                <main className="flex-1 p-8 space-y-8">
                    {tab === "Dashboard" && (
                        <DashboardModule enlargedCard={enlargedCard} setEnlargedCard={setEnlargedCard} baseUrl={baseUrl} currentUser={currentUser} setTab={setTab} setSelectedAgent={setSelectedAgent} tab={tab} />
                    )}

                    {tab === "Agenter" && (
                        <AgentsModule tab={tab} setTab={setTab} baseUrl={baseUrl} currentUser={currentUser} client={client} setSelectedAgent={setSelectedAgent} />
                    )}

                    {tab === "Agent detail" && (
                        <AgentDetailModule tab={tab} setTab={setTab} baseUrl={baseUrl} currentUser={currentUser} client={client} setSelectedAgent={setSelectedAgent} selectedAgent={selectedAgent} />
                    )}

                    {tab === "Kunder" && (
                        <CustomersModule tab={tab} setTab={setTab} currentUser={currentUser} baseUrl={baseUrl} client={client} />
                    )}

                    {tab === "Nummer & telefoni" && (
                        <TelefonSMSModule tab={tab} setTab={setTab} baseUrl={baseUrl} client={client} currentUser={currentUser} />
                    )}

                    {tab === "Administer voip" && (
                        <AdministerVoipModule />
                    )}
                    {tab === "Administer telefoni" && (
                        <AdministerTelefoni client={client} currentUser={currentUser} baseUrl={baseUrl}  />
                    )}

                    {tab === "Ferdigheter" && (
                        <SkillsModule setTab={setTab} baseUrl={baseUrl} client={client} currentUser={currentUser} />
                    )}

                    {tab === "Rapporter & økonomi" && (
                        <ReportsModule baseUrl={baseUrl} client={client} currentUser={currentUser} setActiveTab={setTab} />
                    )}

                    {(tab === "CMS & innhold" || tab === "CMS") && (
                        <CmsAndInnholdModule onRegisterClick={onRegisterClick} baseUrl={baseUrl} client={client} currentUser={currentUser} onLoginClick={onLoginClick} onLoginSuccess={onLoginSuccess} setActiveTab={setTab} />
                    )}

                    {tab === "Blogs" && (
                        <BlogsList tab={tab} setTab={setTab} baseUrl={baseUrl} currentUser={currentUser} client={client} />
                    )}

                    {tab === "Blog detail" && (
                        <BlogDetail baseUrl={baseUrl} client={client} currentUser={currentUser} setActiveTab={setTab} />
                    )}

                    {tab === "Kurs & eventer" && (
                        <KursAndEventerModule currentUser={currentUser} onLogout={onLogout} baseUrl={baseUrl} onLoginClick={onLoginClick} onLoginSuccess={onLoginSuccess} selectedEvent={selectedEvent} setSelectedEvent={setSelectedEvent} setTab={setTab} />
                    )}

                    {tab === "Sosiale medier" && (
                        <SocialMediaModule setActiveTab={setTab} />
                    )}

                    {tab === "Innstillinger" && (
                        <InnstillingerModule client={client} baseUrl={baseUrl} currentUser={currentUser} setActiveTab={setTab} />
                    )}

                </main>
            </div>

            {/* ENLARGED CARD MODAL */}
            {enlargedCard && (
                <EnlargedCardModalModule enlargedCard={enlargedCard} setEnlargedCard={setEnlargedCard} />
            )}
        </div>
    );
}
